import $ from 'jquery';
import MobileDetect from 'mobile-detect';
import 'bootstrap';

window.$ = $;
window.jQuery = $;

const navbarBreakpoint = 992;
const phoneBreakpoint = 576;

global.App = {
    init: function () {
        App.navbar('ul.navbar-nav .dropdown-toggle');

        $('.custom-file-input').on('change', function() {
            $(this).next('.custom-file-label').addClass('selected').html($(this).val().split('\\').pop());
        });

        $('input[type="radio"], input[type="checkbox"]').on('click', function() {
            if ($(this).prop("checked") === true) {
                $('input[name="' + $(this).attr('name') + '"]:radio').parent().removeClass('highlight');

                $(this).parent().addClass('highlight');
            } else {
                $(this).parent().removeClass('highlight');
            }
        });

        $('[data-toggle="tooltip"]').tooltip();

        if ($('input:checked').length > 0) {
            $('input:checked').parent().addClass('highlight');
        }

        $('.auto-hide').hide();
    },
    navbar: function(selector) {
        var dropdowns = $(selector);

        if (dropdowns.length) {
            var md = new MobileDetect(window.navigator.userAgent);

            dropdowns.each(function() {
                var elem = $(this);

                if (md.mobile()) {
                    App.navbarTouch(elem);

                    $(window).on('resize', function() {
                        App.navbarTouch(elem);
                    });
                } else {
                    App.navbarTouch(elem);

                    if (elem.data('hover') == '1') {
                        App.navbarHover(elem);
                    }

                    $(window).on('resize', function() {
                        App.navbarTouch(elem);

                        if (elem.data('hover') == '1') {
                            App.navbarHover(elem);
                        }
                    });
                }
            });
        }
    },
    navbarHover: function(selector) {
        selector.parent().hover(function() {
            if ($(window).innerWidth() >= navbarBreakpoint) {
                $(this).addClass('show');
                $(this).find('.dropdown-menu').addClass('show');
            }
        }, function() {
            if ($(window).innerWidth() >= navbarBreakpoint) {
                $(this).removeClass('show');
                $(this).find('.dropdown-menu').removeClass('show');
            }
        });

        if ($(window).innerWidth() >= navbarBreakpoint) {
            selector.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                window.location.assign(this.href);
            });
        } else {
            selector.unbind('click');
        }
    },
    navbarTouch: function(selector) {
        if (selector.attr('href').substr(0, 1) != '#') {
            var dropdown = selector.next('.dropdown-menu');

            if ($(window).innerWidth() >= navbarBreakpoint) {
                dropdown.find('.cloned').remove();
            } else {
                var replacement = selector.clone();
                replacement.removeClass('dropdown-toggle')
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .removeClass('nav-link')
                    .addClass('cloned dropdown-item');

                dropdown.find('.cloned').remove();
                dropdown.prepend(replacement);
            }
        }
    },
    stripePay: function(key, selector, wrapper, errors, name, email, type) {
        if ($(wrapper).html().length) {
            return true;
        }

        var stripe = Stripe(key),
            form = $(selector),
            btn = form.find('button[type="submit"]').eq(0);

        btn.prop('disabled', true);

        $.post(
            '/wp-content/themes/pallasart/ajax.php?action=stripe_pay_intent',
            form.serialize(),
            function(response) {
                var elements = stripe.elements();
                var card = elements.create(
                    'card',
                    {
                        style: {
                            base: {
                                color: "#495057",
                                fontFamily: 'Cabin, sans-serif',
                                fontSmoothing: "antialiased",
                                fontSize: "16px",
                                "::placeholder": {
                                    color: "#6c757d"
                                }
                            },
                            invalid: {
                                fontFamily: 'Cabin, sans-serif',
                                color: "#dc3545",
                                iconColor: "#dc3545"
                            }
                        }
                    }
                );

                card.mount(wrapper);

                card.on('change', function (event) {
                    btn.prop('disabled', event.empty);

                    if (event.error) {
                        $(errors).html($('<div/>', {
                            class: 'alert alert-danger',
                            text: event.error.message
                        }).prepend($('<span/>', {
                            class: 'fa fa-fw fa-exclamation-triangle'
                        })));
                    } else {
                        $(errors).text('');
                    }
                });

                form.on('submit', function(event) {
                    event.preventDefault();
                    btn.prop('disabled', true);
                    btn.append('<i class="fa fa-spinner fa-spin ml-2"></i>');

                    stripe
                        .confirmCardPayment(response.clientSecret, {
                            receipt_email: $(email).val(),
                            payment_method: {
                                card: card,
                                billing_details: {
                                    name: $(name).val(),
                                    email: $(email).val()
                                }
                            }
                        })
                        .then(function(result) {
                            if (result.error) {
                                $(errors).html($('<div/>', {
                                    class: 'alert alert-danger',
                                    text: result.error.message
                                }).prepend($('<span/>', {
                                    class: 'fa fa-fw fa-exclamation-triangle'
                                })));
                            } else {
                                $(errors).text('');

                                $.post(
                                    '/wp-content/themes/pallasart/ajax.php?action=stripe_pay',
                                    {
                                        transaction: result.paymentIntent.id,
                                        type: $(type).val()
                                    },
                                    function(save) {
                                        btn.prop('disabled', false);
                                        btn.find('.fa-spinner').remove();

                                        if (save.error) {
                                            $(errors).html($('<div/>', {
                                                class: 'alert alert-danger',
                                                text: save.error
                                            }).prepend($('<span/>', {
                                                class: 'fa fa-fw fa-exclamation-triangle'
                                            })));
                                        }

                                        if (save.success) {
                                            window.location.reload();
                                        }
                                    },
                                    'json'
                                );
                            }
                        });
                });
            },
            'json'
        );
    },
    stripeSubscribe: function(key, selector, wrapper, errors, name, email, type) {
        if ($(wrapper).html().length) {
            return true;
        }

        var stripe = Stripe(key),
            form = $(selector),
            btn = form.find('button[type="submit"]').eq(0);

        btn.prop('disabled', true);

        var elements = stripe.elements();
        var card = elements.create(
            'card',
            {
                style: {
                    base: {
                        color: "#495057",
                        fontFamily: 'Cabin, sans-serif',
                        fontSmoothing: "antialiased",
                        fontSize: "16px",
                        "::placeholder": {
                            color: "#6c757d"
                        }
                    },
                    invalid: {
                        fontFamily: 'Cabin, sans-serif',
                        color: "#dc3545",
                        iconColor: "#dc3545"
                    }
                }
            }
        );

        card.mount(wrapper);

        card.on('change', function (event) {
            btn.prop('disabled', event.empty);

            if (event.error) {
                $(errors).html($('<div/>', {
                    class: 'alert alert-danger',
                    text: event.error.message
                }).prepend($('<span/>', {
                    class: 'fa fa-fw fa-exclamation-triangle'
                })));
            } else {
                $(errors).text('');
            }
        });

        form.on('submit', function(event) {
            event.preventDefault();
            btn.prop('disabled', true);
            btn.append('<i class="fa fa-spinner fa-spin ml-2"></i>');

            stripe
                .createPaymentMethod({
                    type: 'card',
                    card: card,
                    billing_details: {
                        name: $(name).val(),
                        email: $(email).val()
                    }
                })
                .then(function(response) {
                    if (response.error) {
                        $(errors).html($('<div/>', {
                            class: 'alert alert-danger',
                            text: response.error.message
                        }).prepend($('<span/>', {
                            class: 'fa fa-fw fa-exclamation-triangle'
                        })));
                    } else {
                        $(errors).text('');

                        $.post(
                            '/wp-content/themes/pallasart/ajax.php?action=stripe_subscribe',
                            {
                                name: $(name).val(),
                                email: $(email).val(),
                                method: response.paymentMethod.id,
                                type: $(type).val()
                            },
                            function(result) {
                                btn.prop('disabled', false);
                                btn.find('.fa-spinner').remove();

                                if (result.error) {
                                    $(errors).html($('<div/>', {
                                        class: 'alert alert-danger',
                                        text: result.error
                                    }).prepend($('<span/>', {
                                        class: 'fa fa-fw fa-exclamation-triangle'
                                    })));
                                }

                                if (result.incomplete) {
                                    stripe
                                        .confirmCardPayment(result.incomplete.latest_invoice.payment_intent.client_secret)
                                        .then(function(res) {
                                            if (res.error) {
                                                $(errors).html($('<div/>', {
                                                    class: 'alert alert-danger',
                                                    text: res.error
                                                }).prepend($('<span/>', {
                                                    class: 'fa fa-fw fa-exclamation-triangle'
                                                })));
                                            } else {
                                                $.post(
                                                    '/wp-content/themes/pallasart/ajax.php?action=stripe_subscribe_incomplete',
                                                    {
                                                        subscription: result.incomplete.id,
                                                        type: $(type).val()
                                                    },
                                                    function(result) {
                                                        if (result.success) {
                                                            window.location.reload();
                                                        }
                                                    }
                                                );
                                            }
                                        });
                                }

                                if (result.success) {
                                    window.location.reload();
                                }
                            },
                            'json'
                        );
                    }
                });
        });
    },
    stripeCancel: function(transaction_id, errors) {
        $.post(
            '/wp-content/themes/pallasart/ajax.php?action=stripe_subscribe_cancel',
            {
                transaction: transaction_id
            },
            function(response) {
                if (response.error) {
                    $(errors).html($('<div/>', {
                        class: 'alert alert-danger',
                        text: response.error
                    }).prepend($('<span/>', {
                        class: 'fa fa-fw fa-exclamation-triangle'
                    })));
                }

                if (response.success) {
                    window.location.reload();
                }
            },
            'json'
        );

        return false;
    }
};

$(function() {
    App.init();
});
